module.exports = __webpack_public_path__ + "img/21.1f6ff526.png";